export default "__VITE_ASSET__BT$PjSJU__"